const menuItems = state => state.items
const menuItemsFooter = state => state.itemsFooter

export {
  menuItems,
  menuItemsFooter
}
